export const StatCard = ({ value, label, sublabel, colorClass, icon: Icon, onClick }) => (
  <div 
    className={`stat-card border-pulse ${onClick ? 'clickable' : ''}`} 
    data-testid={`stat-card-${label.toLowerCase().replace(/\s/g, '-')}`}
    onClick={onClick}
  >
    <div className="stat-card-header">
      <div>
        <div className={`stat-value ${colorClass}`}>{value}</div>
        <div className="stat-label">{label}</div>
        <div className="stat-sublabel">{sublabel}</div>
      </div>
      <Icon className={`stat-icon ${colorClass}`} />
    </div>
  </div>
);
